import _, { round, sumBy } from "lodash";
import { usePublishinRoyaltiesDetails } from "./hooks";
import PublishingRoyaltiesDetailsPresenter from "./PublishingRoyaltiesDetailsPresenter";
import { useContext, useMemo } from "react";
import { mapTypeGroup } from "./utils";
import AppContext from "src/AppContext";
import UnavailableContent from "@arelia-components/ui-atoms/UnavailableContent";
import { Box } from "@mui/material";
import { SubscriptionPlanName } from "@arelia-types/subscriptions";

export default function PublishingRoyaltiesDetailsContainer() {
  const { data, isLoading } = usePublishinRoyaltiesDetails();
  const { account } = useContext(AppContext);

  const stats = useMemo(() => ({
    amountEarned: round(sumBy(data, x => x.amountEarned), 2),
    byTypes: _(data).groupBy(x => mapTypeGroup(x.typeGroup)).entries()
      .map(([k, v]) => ({ label: k, value: round(sumBy(v, x => x.amountEarned), 2) }))
      .sortBy(x => x.label).value(),
    periods: _(data).groupBy(x => x.reportedOn).mapValues(g => round(sumBy(g, x => x.amountEarned), 2)).value()
  }), [data]);

  return account?.plan === SubscriptionPlanName.Starter
    ? <Box sx={{ height: "300px" }}>
        <UnavailableContent message="To have an access to Publishing Royalties Details upgrade to Premium" />
      </Box>
    : <PublishingRoyaltiesDetailsPresenter data={data} stats={stats} isLoading={isLoading} />;
}
